import React, { Component } from 'react';

import AirSlider from '../../../../../../common/components/AirSlider';

import isFunction from 'lodash/isFunction';

import { inject, observer } from 'mobx-react';
import './TotalKmFilter.css';

@inject('translationsStore', 'carsStore')
@observer
export default class TotalKmFilter extends Component {
  constructor(props) {
    super(props);

    this.state = { visible: this.props.visible };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status !== this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  changeTotalKm = totalKm => {
    this.setState({ totalKm });
    this.props.carsStore.appliedFilters.totalKmMin = totalKm[0];
    this.props.carsStore.appliedFilters.totalKmMax = totalKm[1];
  };

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        totalKm: null
      });
    }
  };

  render() {
    const { translationsStore, carsStore } = this.props;
    const { totalKm } = this.state;

    return (
      <div className="totalKm">
        <AirSlider
          label={translationsStore.translate('advancedfilter.totalKm')}
          value={totalKm || [carsStore.filters.totalKmMin, carsStore.filters.totalKmMax]}
          disabled={carsStore.filters.totalKmMin === carsStore.filters.totalKmMax}
          min={carsStore.filters.totalKmMin}
          max={carsStore.filters.totalKmMax}
          range
          showLocale={true}
          uom="Km"
          onChange={this.changeTotalKm}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/CarAdvancedFilter/filters/TotalKmFilter/TotalKmFilter.js